import type { DateTime } from 'luxon'
import { useTranslation } from 'next-i18next'

export type ToLocaleStringOptionsWithTimeZone = Parameters<
  DateTime['toLocaleString']
>[0] & {
  timeZone?: string
}

export type ToLocaleStringWithTimeZone = (
  date: DateTime,
  options: ToLocaleStringOptionsWithTimeZone,
) => ReturnType<DateTime['toLocaleString']>

export interface DateToLocalStringHook {
  toLocaleString: ToLocaleStringWithTimeZone
}

export const useDateToLocaleString = (): DateToLocalStringHook => {
  const { i18n } = useTranslation()

  return {
    toLocaleString: (date, options) =>
      date.toLocaleString(options, { locale: i18n.language }),
  }
}
